"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const CardWrapper = _styledComponents.default.div.withConfig({
  displayName: "CardWrapper",
  componentId: "sc-c822i0-0"
})(["outline:none;width:", ";min-height:1px;height:100%;margin:0;padding:0;display:inline-block;vertical-align:top;white-space:normal;"], _ref => {
  let {
    width
  } = _ref;
  return "".concat(width, "%");
});
var _default = exports.default = CardWrapper;